<p-dialog
    header="{{ 'page.commissions.synthese-jure.modals.evaluation' | translate: {jure: jure?.nom} }} "
    [modal]="true"
    [closable]="true"
    [(visible)]="visible"
    appendTo="body"
    [style]="{ width: '70rem', height: '45rem' }">
    <div class="p-3 h-100 w-100">
        @if (hasResult && evaluations?.length === 0) {
            <p-message icon="pi pi-info-circle">{{ 'page.commissions.synthese-jure.modals.evaluation-aucune' | translate: { jure: jure?.nom } }}</p-message>
        } @else if (hasResult && evaluations?.length > 0) {
            <strong class="pb-3">{{ 'page.commissions.synthese-jure.modals.nb-total' | translate: { nbTotal: nbTotal } }}</strong>
            <p-divider />
            <form [formGroup]="formSearch" (submit)="onSubmit()">
                <div class="d-flex flex-wrap gap-3 pb-3">
                    <!-- Filtre Date(s) commission -->
                    <p-floatlabel variant="on" class="flex-grow-1">
                        <p-datePicker
                            id="datesCommission"
                            formControlName="rangeDates"
                            selectionMode="range"
                            dateFormat="dd/mm/yy"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            [showClear]="true">
                        </p-datePicker>
                        <label for="datesCommission">{{ 'page.commissions.synthese-jure.search.date-commission' | translate }}</label>
                    </p-floatlabel>
                    <!-- Filtre Cahiers des charges -->
                    <p-floatlabel variant="on" class="w-50">
                        <p-multiSelect
                            id="cahierCommission"
                            formControlName="cahierCommission"
                            [options]="cahiersList"
                            optionLabel="libelle"
                            display="chip">
                        </p-multiSelect>
                        <label for="cahierCommission">{{ 'page.commissions.synthese-jure.search.cahiers' | translate }}</label>
                    </p-floatlabel>
                    <!-- Bouton de recherche -->
                    <p-button class="outline" label="{{ 'label.filtrer' | translate }}" icon="pi pi-search" type="submit" [outlined]="true"></p-button>
                </div>
            </form>
            @if (evaluationsPeriode?.length === 0 || evaluationsGroupedByCommission?.length === 0) {
                <p-message icon="pi pi-info-circle">{{ 'page.commissions.synthese-jure.modals.evaluation-aucune-periode' | translate }}</p-message>
            } @else {
                <div class="d-flex justify-content-between gap-3 p-3">
                    <span>{{ 'page.commissions.synthese-jure.modals.nb-debut' | translate: { nbAvantPeriode: nbAvantPeriode } }}</span>
                    <span>{{ 'page.commissions.synthese-jure.modals.nb-obtenus' | translate: { nbPeriode: nbPeriode } }}</span>
                    <span>{{ 'page.commissions.synthese-jure.modals.nb-fin' | translate: { nbFin: nbAvantPeriode + nbPeriode } }}</span>
                </div>
                @if (evaluationsPeriode?.length > 0 && evaluationsGroupedByCommission?.length > 0) {
                    <p-table [value]="evaluationsGroupedByCommission" [scrollable]="true" scrollHeight="flex">
                        <ng-template pTemplate="header">
                            <tr>
                                <th scope="col">{{ 'page.commissions.synthese-jure.modals.dateCommission' | translate }}</th>
                                <th scope="col">{{ 'page.commissions.synthese-jure.modals.leurre' | translate }}</th>
                                @for (critere of criteresPeriode; track critere.id) {
                                    <th scope="col">{{ critere.libelleCritere }}</th>
                                }
                                <th scope="col">{{ 'page.commissions.synthese-jure.modals.nb-points' | translate }}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-evaluation>
                            <tr>
                                <td>{{ evaluation.dateCommission | date: 'dd/MM/yyyy' }}</td>
                                <td>{{ evaluation.evaluations[0].typeLeurre }}</td>
                                @for (critere of criteresPeriode; track critere.id) {
                                    <td>{{ getValueCritere(critere.id) }}</td>
                                }
                                <td>{{ getNbPoints(evaluation.evaluations) }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                }
            }
        }
    </div>
</p-dialog>
